export default __webpack_public_path__ + "static/media/movies.c10482c6.jpg";